import { MessageRow } from '../../../generated/api/chat-room'

export interface ChatMessageMedia {
  _id: string
  url?: string
  thumbUrl?: string
  createdAt?: string
}

export const messageRowMedia = (
  row: Pick<MessageRow, 'media' | 'createdAt'>
): ChatMessageMedia[] => {
  const createdAt = new Date(row.createdAt).toISOString()
  return row.media.map((item) => ({
    _id: item.id,
    url: item.url,
    thumbUrl: item.thumbUrl,
    createdAt,
  }))
}
